export default class CreditCard {
  cardNumber: string;
  cardOwner: string;
  cvc: string;
  expiryMonth: string;
  expiryYear: string;
  cardType: string;
  expiryYearShort: string;
}
